(() => {
  let retailMoneyFormat;
  const formatRetailMoney = (amount, currency) => {
    const locale = document.documentElement.lang || 'en';
    const key = JSON.stringify([locale, currency]);
    if (retailMoneyFormat?.key !== key) retailMoneyFormat = { key, formatter: new Intl.NumberFormat(locale, { style: 'currency', currency }) };
    const formatter = retailMoneyFormat.formatter;
    const parts = formatter.formatToParts(amount);
    const whole = Number.isInteger(amount);
    return parts.filter(part => !whole || (part.type !== 'decimal' && part.type !== 'fraction')).map(part => part.value).join('');
  };
if(customElements.get('stellar-shopping-bar')) return;
customElements.define('stellar-shopping-bar',class extends HTMLElement{
connectedCallback(){
if(this.lifecycle) return;
this.lifecycle=new AbortController();
this.listen=(target,type,listener,options={})=>target.addEventListener(type,listener,{...options,signal:this.lifecycle.signal});
this.sessionKey='stellar-shopbar-viewed-product:'+String(window.Shopify?.theme?.id||'');
this.isExcludedPage=()=>document.body.classList.contains('template-page-customer-service')||/\/pages\/customer-service\/?$/.test(location.pathname);
this.activate=()=>{
if(this.isExcludedPage()){this.hidden=true;document.body.classList.remove('stellar-shopbar-present');return;}
let qualified=this.dataset.pageType==='product';
try{
if(qualified) sessionStorage.setItem(this.sessionKey,'1');
qualified=qualified||sessionStorage.getItem(this.sessionKey)==='1';
}catch(e){ qualified=qualified||window.__stellarShopbarProductSession===this.sessionKey; }
if(this.dataset.pageType==='product') window.__stellarShopbarProductSession=this.sessionKey;
if(qualified&&!this.ready)this.initialize();
this.updateVisibility?.();
};
this.listen(window,'pageshow',this.activate);
this.listen(window,'popstate',this.activate);
this.activate();
}
initialize(){
if(this.ready) return; this.ready=true;
this.catalog=JSON.parse(this.querySelector('[data-shop-catalog]').textContent);
this.groups=new Map();
for(const p of this.catalog){
if(/freight-protection|gift-wrap|personalisation|signature-on-delivery/.test(p.handle))continue;
const standard=/^omnia-styler-(25|32|40)mm-/.test(p.handle);
const key=standard?'omnia-styler':p.handle;
if(!this.groups.has(key)) this.groups.set(key,[]);
this.groups.get(key).push(p);
}
if(!this.groups.size) return;
const get=s=>this.querySelector(s);
const selectedURL=variant=>{
const url=new URL(this.selected.url,location.origin);
const root=this.dataset.root||'/';
if(root!=='/'&&!url.pathname.startsWith(root))url.pathname=root.replace(/\/$/,'')+url.pathname;
url.searchParams.set('variant',variant.id);
const preview=new URL(location.href).searchParams.get('preview_theme_id');
if(preview)url.searchParams.set('preview_theme_id',preview);
return url;
};
this.updateProductLinks=()=>{
const variant=this.selected?.variants.find(v=>String(v.id)===this.variantSelect.value);
const enabled=!!variant;
for(const link of this.querySelectorAll('[data-shop-product-link]')){
if(enabled){link.href=selectedURL(variant).href;link.tabIndex=0;link.setAttribute('aria-label','View '+this.selected.title);}
else{link.removeAttribute('href');link.tabIndex=-1;link.removeAttribute('aria-label');}
}
};
this.productSelect=get('[data-shop-product]');this.sizeSelect=get('[data-shop-size]');this.colourSelect=get('[data-shop-colour]');this.variantSelect=get('[data-shop-variant]');
this.add=get('[data-shop-add]');this.checkout=get('[data-shop-checkout]');this.status=get('[data-shop-status]');
this.observer=new MutationObserver(()=>{this.syncFromForm?.();this.update?.();});
this.resolveForm=()=>{
let button=get('[data-shop-submit]');
if(this.dataset.current){
const sections=[...document.querySelectorAll('main [id^="MainProduct-"]')].filter(section=>!section.closest('quick-add-modal'));
const buttons=sections.flatMap(section=>[...section.querySelectorAll('product-form button[type="submit"]')].filter(item=>item.id==='ProductSubmitButton-'+section.dataset.section&&item.form?.getAttribute('id')==='product-form-'+section.dataset.section));
button=buttons.find(item=>item.getClientRects().length)||buttons[0];
}
if(!button?.form||!button.isConnected){this.mainButton=null;this.form=null;return false;}
if(this.mainButton!==button||this.form!==button.form){
this.mainButton=button;this.form=button.form;
this.observer.disconnect();
this.observer.observe(button,{attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
const input=this.form.querySelector('[name="id"]');
if(this.dataset.current&&input)this.observer.observe(input,{attributes:true,attributeFilter:['value','disabled']});
}
return true;
};
this.picker=()=>{
const section=this.form?.closest('[id^="MainProduct-"]');
return [...(section?.querySelectorAll('variant-selects,variant-radios')||[])].find(picker=>picker.dataset.section===section.dataset.section);
};
this.currentVariant=()=>{
if(!this.form||!this.selected)return null;
const picker=this.dataset.current?this.picker():null;
if(picker){
const values=[...picker.querySelectorAll('fieldset')].map(fieldset=>fieldset.querySelector('select')?.value??fieldset.querySelector('input[type="radio"]:checked')?.value);
if(values.length)return this.selected.variants.find(variant=>variant.options.length===values.length&&variant.options.every((value,index)=>String(value)===values[index]))||null;
}
const id=String(new FormData(this.form).get('id')||'');
return this.selected.variants.find(variant=>String(variant.id)===id)||null;
};
this.syncFromForm=()=>{
if(!this.resolveForm()||!this.dataset.current||this.navigating||this.selected?.handle!==this.dataset.current)return;
const variant=this.currentVariant();
if(this.variantIntent){
if(String(variant?.id)!==this.variantIntent||String(new FormData(this.form).get('id'))!==this.variantIntent)return;
if(!this.mainButton.disabled)this.variantIntent=null;
}
if(variant)this.variantSelect.value=String(variant.id);
};
this.selectCurrentVariant=variant=>{
if(!this.resolveForm())return false;
const picker=this.picker();
if(!picker)return String(new FormData(this.form).get('id'))===String(variant.id);
const fieldsets=[...picker.querySelectorAll('fieldset')];
const controls=fieldsets.map((fieldset,index)=>{
const select=fieldset.querySelector('select');
const value=variant.options[index];
return select?[...select.options].some(option=>option.value===value)&&select:[...fieldset.querySelectorAll('input[type="radio"]')].find(input=>input.value===value);
});
if(fieldsets.length!==variant.options.length||controls.some(control=>!control))return false;
let changed;
controls.forEach((control,index)=>{
if(control.tagName==='SELECT'){if(control.value!==variant.options[index])changed=control;control.value=variant.options[index];}
else{if(!control.checked)changed=control;control.checked=true;}
});
if(changed){this.selectingVariant=true;try{changed.dispatchEvent(new Event('change',{bubbles:true}));}finally{this.selectingVariant=false;}}
this.update();
return String(new FormData(this.form).get('id'))===String(variant.id);
};
this.resolveForm();
this.productSelect.replaceChildren();
for(const [key,products] of this.groups){this.productSelect.add(new Option(key==='omnia-styler'?'Omnia Styler®':products[0].title,key));}
this.productSelect.value=[...this.groups].find(([,ps])=>ps.some(p=>p.handle===this.dataset.current))?.[0]||(this.groups.has('omnia-styler')?'omnia-styler':this.groups.keys().next().value);
const compactMillimetres=text=>text.replace(/\b(\d+(?:\.\d+)?)\s+mm\b/g,'$1mm');
const fill=(select,values,value)=>{select.replaceChildren(...values.map(v=>new Option(v,v)));if(values.includes(value))select.value=value;};
this.renderChoices=()=>{
const ps=this.groups.get(this.productSelect.value);const styler=this.productSelect.value==='omnia-styler';
get('[data-size-label]').hidden=!styler;get('[data-colour-label]').hidden=!styler;
if(styler){
const oldSize=this.sizeSelect.value||this.dataset.current.match(/(25|32|40)mm/)?.[1]+' mm';
fill(this.sizeSelect,[...new Set(ps.map(p=>p.handle.match(/(25|32|40)mm/)[1]+' mm'))].sort(),oldSize);
for(const option of this.sizeSelect.options)option.textContent=compactMillimetres(option.value);
fill(this.colourSelect,['White','Black'],this.colourSelect.value||(this.dataset.current.includes('black')?'Black':'White'));
for(const option of this.colourSelect.options)option.textContent=option.value==='Black'?'Astral Black':'Pearl White';
}
this.renderProduct();
};
this.renderProduct=()=>{
const ps=this.groups.get(this.productSelect.value);
this.selected=this.productSelect.value==='omnia-styler'?ps.find(p=>p.handle.includes(this.sizeSelect.value.replace(' ',''))&&(this.colourSelect.value==='Black'?p.handle.includes('black'):p.handle.includes('white'))):ps[0];
if(!this.selected){this.updateProductLinks();this.status.textContent='This combination is not available.';this.add.disabled=this.checkout.disabled=true;return;}
const p=this.selected;
get('[data-shop-image]').src=p.image;get('[data-shop-title]').textContent=p.title;
get('[data-variant-label]').hidden=p.variants.length<2;
const old=this.variantSelect.value||this.dataset.variant;
this.variantSelect.replaceChildren(...p.variants.map(v=>new Option(v.title==='Default Title'?'Standard':(p.handle.startsWith('omnia-styler')?v.title.split(' / ').map(value=>value==='Black'?'Astral Black':value==='White'?'Pearl White':value).join(' / '):v.title),String(v.id))));
if(p.handle.includes('omnia-styler')||p.handle.includes('heatsense'))for(const option of this.variantSelect.options)option.textContent=compactMillimetres(option.textContent);
if(p.variants.some(v=>String(v.id)===old))this.variantSelect.value=old;
else this.variantSelect.value=String((p.variants.find(v=>v.available)||p.variants[0]).id);
this.update();
};
this.update=()=>{
const v=this.selected?.variants.find(v=>String(v.id)===this.variantSelect.value);
const ready=this.resolveForm();
if(!v||!ready){this.add.disabled=this.checkout.disabled=true;return;}
if(!this.dataset.current&&get('[data-shop-id]').value!==String(v.id))get('[data-shop-id]').value=String(v.id);
this.updateProductLinks();
const pending=this.mainButton.getAttribute('aria-disabled')==='true'||this.mainButton.getAttribute('aria-busy')==='true';
const current=this.dataset.current?this.currentVariant():v;
const matched=!this.dataset.current||(this.selected.handle===this.dataset.current&&String(current?.id)===String(v.id)&&String(new FormData(this.form).get('id'))===String(v.id));
this.add.disabled=this.checkout.disabled=!v.available||pending||this.mainButton.disabled||!matched||!!this.navigating;
this.add.querySelector('span').textContent=!v.available?'Sold out':pending?'Adding…':'Add to bag';
get('[data-shop-price]').textContent=formatRetailMoney((this.dataset.current?(v.price*Math.max(1,Number(new FormData(this.form).get('quantity'))||1)+[...this.form.querySelectorAll('[data-addon-price]:checked:not(:disabled)')].reduce((total,input)=>total+Number(input.dataset.addonPrice)*Math.max(1,Number(new FormData(this.form).get('quantity'))||1),0)):v.price)/100, this.dataset.currency || 'AUD');
const error=this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');this.status.textContent=error?.textContent||(!matched&&this.variantIntent?(window.stellarStrings?.checkSelection||'Please check your product selection.'):'');

this.updateVisibility();
};
this.updateVisibility=()=>{
const overlay=document.querySelector('cart-drawer.active,quick-add-modal[open],modal-dialog[open],product-modal[open],dialog[open],.menu-drawer-container.menu-opening,details-modal details[open],#search-modal[open],#search-modal.active');
const active=document.activeElement;
const editing=active&&!this.contains(active)&&(active.matches('textarea,[contenteditable="true"]')||(active.tagName==='INPUT'&&['text','search','email','url','tel','password','number'].includes(active.type)));
const checkoutVisible=this.dataset.pageType==='cart'&&[...document.querySelectorAll('#main-cart-footer [name="checkout"],.cart__checkout-button,[data-shopify="payment-button"]')].some(el=>{
const rect=el.getBoundingClientRect();
return rect.width>0&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight&&rect.right>0&&rect.left<window.innerWidth;
});
this.hidden=!!(this.isExcludedPage()||overlay||editing||checkoutVisible);
};
// Carry expansion only across this bar's navigation, never as a global preference.
const stateKey='stellar-shopbar-open:'+String(window.Shopify?.theme?.id||'');
const setOpen=open=>{
this.classList.toggle('is-expanded',open);get('[data-shop-toggle]').setAttribute('aria-expanded',String(open));get('[data-shop-chevron]').textContent=open?'−':'+';
try{history.replaceState({...history.state,[stateKey]:open},'');}catch(e){}
};
let restore=false;
try{
const intent=JSON.parse(sessionStorage.getItem(stateKey)||'null');
sessionStorage.removeItem(stateKey);
restore=!!(intent&&intent.url===location.href&&Date.now()-intent.time<30000);
if(performance.getEntriesByType('navigation')[0]?.type==='back_forward')restore=history.state?.[stateKey]===true;
}catch(e){}
setOpen(restore);
const navigateToSelection=(variant,hash='')=>{
const url=selectedURL(variant);
url.hash=hash;
this.navigating=true;this.add.disabled=this.checkout.disabled=true;
try{
sessionStorage.removeItem(stateKey);
if(this.classList.contains('is-expanded'))sessionStorage.setItem(stateKey,JSON.stringify({url:url.href,time:Date.now()}));
}catch(e){}
location.assign(url.href);
};
for(const link of this.querySelectorAll('[data-shop-product-link]'))this.listen(link,'click',()=>{
if(!link.hasAttribute('href'))return;
try{sessionStorage.removeItem(stateKey);if(this.classList.contains('is-expanded'))sessionStorage.setItem(stateKey,JSON.stringify({url:link.href,time:Date.now()}));}catch(e){}
});
this.listen(window,'resize',this.updateProductLinks);
const navigateSelection=()=>{if(!this.dataset.current)return;const v=this.selected?.variants.find(v=>String(v.id)===this.variantSelect.value);if(!v)return;if(this.selected.handle!==this.dataset.current){navigateToSelection(v);return;}this.variantIntent=String(v.id);if(!this.selectCurrentVariant(v)){this.add.disabled=this.checkout.disabled=true;this.status.textContent=window.stellarStrings?.checkSelection||'Please check your product selection.';}};
this.listen(this.productSelect,'change',()=>{this.renderChoices();navigateSelection();});this.listen(this.sizeSelect,'change',()=>{this.renderProduct();navigateSelection();});this.listen(this.colourSelect,'change',()=>{this.renderProduct();navigateSelection();});this.listen(this.variantSelect,'change',()=>{this.update();navigateSelection();});
this.listen(get('[data-shop-toggle]'),'click',()=>{
setOpen(!this.classList.contains('is-expanded'));
try{sessionStorage.removeItem(stateKey);}catch(e){}
});
// The entire closed mobile bar accepts an upward swipe, including its links and Shop button.
let openingSwipe=null;
let suppressSwipeClick=false;
const cancelOpeningSwipe=()=>{openingSwipe=null;};
this.listen(this,'pointerdown',event=>{
if(!event.isPrimary){cancelOpeningSwipe();return;}
suppressSwipeClick=false;
if(!matchMedia('(max-width:749px)').matches||this.classList.contains('is-expanded')||event.button!==0)return;
// Do not capture here: an ordinary tap must still click its original link or button.
openingSwipe={id:event.pointerId,x:event.clientX,y:event.clientY};
});
this.listen(document,'pointerup',event=>{
if(!openingSwipe||event.pointerId!==openingSwipe.id)return;
const start=openingSwipe;cancelOpeningSwipe();
const dx=event.clientX-start.x,up=start.y-event.clientY;
if(up>=40&&up>Math.abs(dx)*1.5&&!this.classList.contains('is-expanded')&&matchMedia('(max-width:749px)').matches){
suppressSwipeClick=true;
setOpen(true);
try{sessionStorage.removeItem(stateKey);}catch(e){}
}
});
this.listen(this,'click',event=>{
if(!suppressSwipeClick||event.detail===0)return;
suppressSwipeClick=false;
event.preventDefault();
event.stopImmediatePropagation();
},{capture:true});
this.listen(this,'dragstart',event=>{if(openingSwipe)event.preventDefault();});
this.listen(document,'pointerdown',event=>{if(openingSwipe&&!event.isPrimary)cancelOpeningSwipe();},{capture:true,passive:true});
this.listen(document,'pointercancel',cancelOpeningSwipe,{passive:true});
this.listen(window,'pagehide',()=>{cancelOpeningSwipe();suppressSwipeClick=false;});
this.listen(window,'resize',cancelOpeningSwipe);
// Only the dedicated drag strip owns this gesture; selects and page scrolling remain native.
const drag=get('[data-shop-drag]');
if(drag){
let swipe=null;
this.listen(drag,'pointerdown',event=>{
if(!event.isPrimary||!['touch','pen'].includes(event.pointerType)||!matchMedia('(max-width:1179px)').matches||!this.classList.contains('is-expanded'))return;
swipe={id:event.pointerId,x:event.clientX,y:event.clientY};
drag.setPointerCapture(event.pointerId);
});
this.listen(drag,'pointerup',event=>{
if(!swipe||event.pointerId!==swipe.id)return;
const dx=event.clientX-swipe.x,dy=event.clientY-swipe.y;swipe=null;
if(dy>=40&&dy>Math.abs(dx)*1.25){
setOpen(false);
try{sessionStorage.removeItem(stateKey);}catch(e){}
}
});
this.listen(drag,'pointercancel',()=>{swipe=null;});
this.listen(drag,'lostpointercapture',()=>{swipe=null;});
}
const submit=checkout=>{
this.syncFromForm();this.update();
if(this.add.disabled||!this.form||!this.mainButton)return;
const form=this.form,button=this.mainButton;
delete button.dataset.stellarCheckout;
if(!form.reportValidity())return;
button.dataset.stellarCheckout=checkout?'true':'false';
try{form.requestSubmit(button);}finally{delete button.dataset.stellarCheckout;this.update();}
};
this.listen(this.add,'click',()=>submit(false));this.listen(this.checkout,'click',()=>submit(true));
const formChanged=event=>{
this.resolveForm();
if(event.target===this.form||event.target.form===this.form||this.form?.contains(event.target)||this.picker()?.contains(event.target)){
if(!this.selectingVariant&&this.picker()?.contains(event.target))this.variantIntent=null;
this.syncFromForm();this.update();
}
};
this.listen(document,'stellar:purchase-state',formChanged);this.listen(document,'change',formChanged);
this.listen(document,'stellar:product-form-ready',()=>{this.syncFromForm();this.update();});
this.listen(document,'shopify:section:load',()=>{this.syncFromForm();this.update();});
this.listen(window,'pageshow',()=>{this.navigating=false;this.syncFromForm();this.update();});
this.overlayObserver=new MutationObserver(records=>{
if(records.some(record=>!this.contains(record.target))){this.updateVisibility();if(records.some(record=>record.type==='childList'&&!this.contains(record.target))){this.syncFromForm();this.update();}}
});
this.overlayObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden']});
// Desktop alignment follows the shared CSS grid without DOM measurement.

this.listen(window,'resize',this.updateVisibility);
this.listen(window,'load',this.updateVisibility,{once:true});
this.listen(document,'focusin',this.updateVisibility);
this.listen(document,'focusout',()=>queueMicrotask(()=>{if(this.isConnected)this.updateVisibility();}));
if(this.dataset.pageType==='cart')this.listen(window,'scroll',this.updateVisibility,{passive:true});
this.renderChoices();this.syncFromForm();this.update();document.body.classList.add('stellar-shopbar-present');this.updateVisibility();
}
disconnectedCallback(){this.lifecycle?.abort();this.lifecycle=null;this.ready=false;this.observer?.disconnect();this.overlayObserver?.disconnect();document.body.classList.remove('stellar-shopbar-present');this.hidden=true;}
});
})();
